<div class="" [class.opacity]="item.start ? item.start.active : false">
    <div class="title border-bottom">
        <span class="ttl">{{item.title}}</span>
        <div class="date d-flex justify-content-between">
            <span class="text-primary">
                <i class="fa fa-calendar mr-1 op-5"></i>
                <ng-container *ngIf="item.start?.dateStart">
                    Del {{item.start.dateStart | moment:'ll'}}
                    <ng-container *ngIf="item.start.dateEnd && (item.start.dateStart !== item.start.dateEnd)">
                        al {{item.start.dateEnd | moment:'ll'}}
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!item.start?.dateStart && item.date">
                    {{item.date | moment:'ll'}}
                </ng-container>
            </span>
            <span class="typo"><i class="fa fa-circle mr-1 {{item.type | lowercase}}"></i>{{typeName[item.type] || item.type}}</span>
        </div>
    </div>
    <div class="bg-white">
        <div class="cert d-flex justify-content-between">
            <span>Descripción: <b>{{item?.duration}}</b></span>
            <span class="bdg" *ngIf="item?.certification?.length"><i class="fa fa-graduation-cap mr-2"></i>{{item?.certification}}</span>
        </div>
        <div class="address text-primary" *ngIf="item?.address"><i class="fa fa-building mr-2"></i> {{item?.address}}</div>
        <div class="bot border-top">
            <ng-container *ngIf="item.userData?.name">
                <div class="_user">
                    <div class="img" *ngIf="img"><img [src]="img" alt="Instructor"></div>
                    <div class="info">
                        <b>Instructor</b>
                        <span>{{item.userData.name}}</span>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="item.institutionName">
                <div class="_user">
                    <div class="info text-right">
                        <b>Institución</b>
                        <span>{{item.institutionName}}</span>
                    </div>
                    <div class="img" *ngIf="imgInstitution"><img [src]="imgInstitution" alt="Institución"></div>
                </div>
            </ng-container>
        </div>
    </div>
</div>